import { expectTypeOf } from 'expect-type';
import { GeneratedAlways, Insertable, Selectable } from 'kysely';
import { DbTimestampGeneratedAlways } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';
import { z } from '@harvestiq/zod';
import { SmsTemplateData, smsTemplateDataSchema } from '@harvestiq/sms-common';

export type SmsNotificationsTable = {
  id: GeneratedAlways<string>;
  phoneNumber: string;
  notificationType: string;
  key: string;
  smsMessageId: string;
  sentAt: DbTimestampGeneratedAlways;
  notificationData: SmsTemplateData;
};

export type DbSmsNotification = Selectable<SmsNotificationsTable>;
export type DbSmsNotificationInsert = Insertable<SmsNotificationsTable>;

export const dbSmsNotificationSchema = z.object({
  id: z.string().uuid(),
  phoneNumber: z.string(),
  notificationType: z.string(),
  key: z.string(),
  smsMessageId: z.string(),
  sentAt: zTimestamp(),
  notificationData: smsTemplateDataSchema,
});

export const dbSmsNotificationInsertSchema = dbSmsNotificationSchema
  .omit({
    id: true,
    sentAt: true,
  })
  .partial();

expectTypeOf<DbSmsNotification>().toMatchTypeOf<
  z.infer<typeof dbSmsNotificationSchema>
>();
expectTypeOf<DbSmsNotificationInsert>().toMatchTypeOf<
  z.infer<typeof dbSmsNotificationInsertSchema>
>();
